











































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Icon from '@/main-components/common/Icon.vue';
import ModalGradePaperPicture from '@/main-components/common/modal/ModalGradePaperPicture.vue';

@Component({
  components: { MainButton, Icon, ModalGradePaperPicture },
})
export default class CameraUpload extends Vue {
  @Prop({ default: { images: [] } })
  imagesObject: { images: any[] };

  @Prop({ default: false })
  isViewOnly: string[];

  openCamera = false;

  videoDevices: any[] = [];
  selectedCamera = null;
  streamStarted = false;
  paused = true;

  selectedImage: any = null;

  openModalGradePaperPicture: any = null;

  async created() {
    if (!this.isViewOnly) {
      if (this.hasCamera()) {
        await this.isAllowedCamera();
        await this.getCameraSelection();
      }
    }
  }

  hasCamera() {
    if (
      'mediaDevices' in navigator &&
      'getUserMedia' in navigator.mediaDevices
    ) {
      return true;
    } else {
      return false;
    }
  }

  async isAllowedCamera() {
    return await navigator.mediaDevices.getUserMedia({ video: true });
  }

  async getCameraSelection() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    this.videoDevices = devices.filter(device => device.kind === 'videoinput');
    if (this.videoDevices.length > 0) {
      this.selectedCamera = this.videoDevices[0].deviceId;
    }
  }

  playVideo() {
    const videoRef = this.$refs.video as any;
    if (!videoRef) return;

    if (this.streamStarted) {
      videoRef.play();
      this.paused = false;
    } else {
      this.startStream();
    }
  }

  async startStream() {
    const constraints = {
      video: {
        deviceId: {
          exact: this.selectedCamera as any,
        },
      },
    };
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    this.handleStream(stream);
  }

  handleStream(stream: MediaStream) {
    const videoRef = this.$refs.video as any;
    if (!videoRef) return;

    videoRef.srcObject = stream;
    this.streamStarted = true;
    this.paused = false;
  }

  takeScreenshot() {
    const canvasRef = this.$refs.canvas as any;
    if (!canvasRef) return;

    const context = canvasRef.getContext('2d');
    context.drawImage(
      this.$refs.video,
      0,
      0,
      canvasRef.width,
      canvasRef.height,
    );

    console.log(
      "canvasRef.toDataURL('image/png'):",
      canvasRef.toDataURL('image/png'),
    );

    // (this.$refs.screenshotImage as any).src = canvasRef.toDataURL('image/png');
    this.imagesObject.images.push(canvasRef.toDataURL('image/png'));
  }

  removeScreenShot(index: number) {
    this.imagesObject.images.splice(index, 1);
  }

  openScreenshot(index: number) {
    this.selectedImage = this.imagesObject.images[index];
    this.openModalGradePaperPicture && this.openModalGradePaperPicture();
  }

  openModalGradePaperPictureAdd(openModal: any) {
    this.openModalGradePaperPicture = openModal;
  }
}
